export var DEFAULT_CALL_FROM_TIME = '10:00';
export var DEFAULT_CALL_TO_TIME = '19:00';
export var DEFAULT_WORK_TIME = {
  callFrom: DEFAULT_CALL_FROM_TIME,
  callTo: DEFAULT_CALL_TO_TIME,
  overridesByDays: []
};
export var DEFAULT_RECOMMENDATION_TIME = 10;